import React, { useState } from 'react';
import {
  vertical_line,
  vertical_first_line
} from './TeamPerformance.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/pro-solid-svg-icons';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { numberFormat } from '../../../../common/constants/NumberFormat';
import { navigate } from 'gatsby';
import {
  getFiltersInfo,
  setFiltersInfo
} from '../../../../common/utils/FiltersInfo';
import moment from 'moment';
import { getAcl } from '../../../../common/utils/acl-utils';

const isAdmin = () =>
  getAcl()?.acl?.is_rm && getAcl()?.acl?.can_create_in_principle_sanction;

const TeamPerformanceTableColumnData = (rmId, filteredProduct, changeMonth) => {
  const commonHeaderStyle = 'w-full  items-end mx-auto text-center',
    commonStyle = 'w-full mx-auto text-center',
    totalCommonStyle = 'w-full mx-auto text-center font-bold',
    commonparentGruopStyle =
      '  mx-auto text-center  mb-2 text font-khand font-sm text-black-500 font-semibold absolute ',
    commonColStyle =
      ' mt-2 text-black-500 text-sm  font-khand font-normal overflow-auto';

  const commonParentGroupStyle = {
    fontWeight: 500,
    fontSize: '14px',
    bottom: '34px'
  };
  const colStyle = { fontWeight: '500', opacity: '0.8' };

  const HeaderCommonFormat = ({
    majorColName = '',
    colName,
    colNameClass = ''
  }) => (
    <div className={`${commonHeaderStyle} `}>
      <p
        className={`${commonparentGruopStyle} `}
        style={commonParentGroupStyle}
      >
        {majorColName}
      </p>
      <p
        className={`${commonColStyle} ${colNameClass} 
        
        `}
        style={colStyle}
      >
        {colName}
      </p>
    </div>
  );
  const verticalLine = {
    width: '10px !important',
    style: {
      paddingLeft: '0px !important',
      paddingRight: '0px !important',
      width: '12px !important'
    }
  };
  const HoverInfo = () => {
    return (
      <div
        className="w-full absolute shadow bg-white rounded px-2 py-3 mb-6"
        style={{ top: '-37px', left: '11px' }}
      >
        <p className="text-grey-2233 font-roboto text-xs">Resigned</p>
      </div>
    );
  };
  function addToLocalStorage(status, row) {
    let filtersData = getFiltersInfo();
    let newFilterData = {
      ...filtersData,
      rmId: rmId || row?.employeeId,
      productId: filteredProduct,
      status: status,
      backPage: 'teamReport',
      targetMonth: changeMonth || {
        year: parseInt(moment().format('YYYY')),
        month: parseInt(moment().format('MM'))
      },
      cityFilter: ''
    };
    setFiltersInfo(newFilterData);
    navigate(`/app/dashboard`);
  }
  return [
    {
      name: <HeaderCommonFormat colName="Employee Name" />,
      selector: 'name',
      sortable: true,
      cell: row => {
        if (row?.isTotal)
          return <div className="w-full font-bold text-base -ml-3">Total</div>;
        const [isHovered, setHovered] = useState(false);
        return (
          <div
            className="flex items-center text-left mr-auto ml-1 px-2 cursor-pointer"
            onClick={() =>
              navigate(`/app/report/performance?user=${row?.employeeId}`)
            }
          >
            <p
              className={`mx-auto text-left ${
                !row?.isActive ? 'text-red-500' : 'text-green-600'
              } capitalize`}
            >
              {row?.empName?.firstName
                ? `${row?.empName?.firstName} ${
                    row?.empName?.middleName ? row?.empName?.middleName : ''
                  } ${row?.empName?.lastName ? row?.empName?.lastName : ''}`
                : '---'}
            </p>
            {!row?.isActive ? (
              <div className="ml-1 text-left">
                {isHovered ? <HoverInfo /> : false}
                <div
                  className="cursor-pointer"
                  onMouseEnter={() => setHovered(true)}
                  onMouseLeave={() => setHovered(false)}
                >
                  <ErrorOutlineIcon
                    style={{ color: '#FD4F60', width: '15px' }}
                  />
                </div>
              </div>
            ) : null}
          </div>
        );
      },
      minWidth: '100px !important'
    },
    {
      name: <HeaderCommonFormat colName="Funnel" />,
      selector: 'funnel',
      sortable: false,
      cell: row => {
        if (!row?.isTotal)
          return (
            <div className={`${commonStyle} `}>
              <FontAwesomeIcon icon={faFilter} style={{ color: '#B2B2B2' }} />
            </div>
          );
      },
      width: '40px !important'
    },
    {
      name: <HeaderCommonFormat colName="BP" />,
      selector: 'bpCount',
      sortable: false,
      cell: row => (
        <p className={row?.isTotal ? totalCommonStyle : commonStyle}>
          {row?.bpCount || 0}
        </p>
      )
    },
    {
      name: <HeaderCommonFormat colName="Txn. BP" />,
      selector: 'tranxBpCount',
      sortable: false,
      cell: row => (
        <p className={row?.isTotal ? totalCommonStyle : commonStyle}>
          {row?.tranxBpCount || 0}
        </p>
      )
    },
    {
      name: '',
      selector: '',
      sortable: false,
      cell: (row, index) => (
        <p
          className={`${index == 0 ? vertical_first_line : vertical_line}`}
        ></p>
      ),
      ...verticalLine
    },
    {
      name: <HeaderCommonFormat colName="Leads" majorColName="Number" />,
      selector: 'leadsTotalCount',
      sortable: false,
      cell: row => (
        <p
          className={`${
            row?.isTotal ? totalCommonStyle : commonStyle
          } ${row?.leadsTotalCount &&
            'cursor-pointer'} text-blue-900 font-medium `}
          onClick={() => row?.leadsTotalCount && addToLocalStorage('', row)}
        >
          {row?.leadsTotalCount || 0}
        </p>
      ),
      width: '60px !important'
    },
    {
      name: <HeaderCommonFormat colName="Rej" />,
      selector: 'leadsRejectCount',
      sortable: false,
      cell: row => (
        <p
          className={`${
            row?.isTotal ? totalCommonStyle : commonStyle
          } ${row?.leadsRejectCount &&
            'cursor-pointer'} text-blue-900 font-medium`}
          onClick={() =>
            row?.leadsRejectCount && addToLocalStorage('Rejected', row)
          }
        >
          {row?.leadsRejectCount || 0}
        </p>
      ),
      width: '50px !important'
    },
    {
      name: <HeaderCommonFormat colName="Logins" />,
      selector: 'leadsLoginCount',
      sortable: false,
      cell: row => (
        <p
          className={`${
            row?.isTotal ? totalCommonStyle : commonStyle
          } ${row?.leadsLoginCount &&
            'cursor-pointer'} text-blue-900 font-medium`}
          onClick={() =>
            row?.leadsLoginCount && addToLocalStorage('Login', row)
          }
        >
          {row?.leadsLoginCount || 0}
        </p>
      ),
      width: '50px !important'
    },
    {
      name: <HeaderCommonFormat colName="Sanc." />,
      selector: 'leadsSanctionCount',
      sortable: false,
      cell: row => (
        <p
          className={`${
            row?.isTotal ? totalCommonStyle : commonStyle
          } ${row?.leadsSanctionCount &&
            'cursor-pointer'} text-blue-900 font-medium`}
          onClick={() =>
            row?.leadsSanctionCount && addToLocalStorage('Sanctioned', row)
          }
        >
          {row?.leadsSanctionCount || 0}
        </p>
      ),
      width: '50px !important'
    },
    {
      name: <HeaderCommonFormat colName="Disb." />,

      selector: 'leadsDisbursedCount',
      sortable: false,
      cell: row => (
        <p
          className={`${
            row?.isTotal ? totalCommonStyle : commonStyle
          } ${row?.leadsDisbursedCount &&
            'cursor-pointer'} text-blue-900 font-medium`}
          onClick={() =>
            row?.leadsDisbursedCount && addToLocalStorage('Disbursed', row)
          }
        >
          {row?.leadsDisbursedCount || 0}
        </p>
      ),
      width: '50px !important'
    },
    {
      name: '',
      selector: '',
      sortable: false,
      cell: (row, index) => (
        <p
          className={`${index == 0 ? vertical_first_line : vertical_line}`}
        ></p>
      ),
      ...verticalLine
    },

    {
      name: <HeaderCommonFormat colName="Leads" majorColName="Amount" />,
      selector: 'leadsLoanAmount',
      sortable: false,
      cell: row => (
        <p
          className={`${
            row?.isTotal ? totalCommonStyle : commonStyle
          } break-normal mx-8 text-right `}
        >
          &#8377;
          <span className="ml-1">
            {row?.leadsLoanAmount ? numberFormat(row?.leadsLoanAmount) : 0}
          </span>
        </p>
      ),
      maxWidth: '300px !important',
      minWidth: '90px !important',
      style: { marginRight: '0px' }
    },
    {
      name: <HeaderCommonFormat colName="Rej" />,
      selector: 'leadsRejectLoanAmount',
      sortable: false,
      cell: row => (
        <p
          className={`${
            row?.isTotal ? totalCommonStyle : commonStyle
          } break-normal text-right `}
        >
          &#8377;
          <span className="ml-1">
            {row?.leadsRejectLoanAmount
              ? numberFormat(row?.leadsRejectLoanAmount)
              : 0}
          </span>
        </p>
      ),
      maxWidth: '300px !important',
      minWidth: '90px !important',
      style: { marginRight: '0px' }
    },
    {
      name: <HeaderCommonFormat colName="Logins" />,
      selector: 'leadsLoginLoanAmount',
      sortable: false,
      cell: row => (
        <p
          className={`${
            row?.isTotal ? totalCommonStyle : commonStyle
          } break-normal text-right `}
        >
          &#8377;
          <span className="ml-1">
            {row?.leadsLoginLoanAmount
              ? numberFormat(row?.leadsLoginLoanAmount)
              : 0}
          </span>
        </p>
      ),
      maxWidth: '300px !important',
      minWidth: '90px !important'
    },
    {
      name: <HeaderCommonFormat colName="Sanc." />,
      selector: 'leadsSanctionLoanAmount',
      sortable: false,
      cell: row => (
        <p
          className={`${
            row?.isTotal ? totalCommonStyle : commonStyle
          } break-normal text-right `}
        >
          &#8377;
          <span className="ml-1">
            {row?.leadsSanctionLoanAmount
              ? numberFormat(row?.leadsSanctionLoanAmount)
              : 0}
          </span>
        </p>
      ),
      maxWidth: '300px !important',
      minWidth: '90px !important'
    },
    {
      name: (
        <div className="w-full pr-2">
          <HeaderCommonFormat colName="Disb." />
        </div>
      ),
      selector: 'leadsDisbursedLoanAmount',
      sortable: false,
      cell: row => (
        <p
          className={`${
            row?.isTotal ? totalCommonStyle : commonStyle
          } break-normal text-right pr-2`}
        >
          &#8377;
          <span className="ml-1">
            {row?.leadsDisbursedLoanAmount
              ? numberFormat(row?.leadsDisbursedLoanAmount)
              : 0}
          </span>
        </p>
      ),
      maxWidth: '300px !important',
      minWidth: '90px !important'
    },
    {
      name: '',
      selector: '',
      sortable: false,
      cell: (row, index) => (
        <p
          className={`${index == 0 ? vertical_first_line : vertical_line}`}
        ></p>
      ),
      ...verticalLine
    },
    {
      name: <HeaderCommonFormat colName="GR" />,
      selector: 'gr',
      sortable: false,
      cell: row => (
        <p className={`${row?.isTotal ? totalCommonStyle : commonStyle}`}>
          {row?.gr ? <span>&#8377;</span> : ''}
          <span className="ml-1">{numberFormat(row?.gr) || '---'}</span>
        </p>
      ),
      maxWidth: '300px !important',
      minWidth: '90px !important',
      omit: !isAdmin()
    },
    {
      name: <HeaderCommonFormat colName="Payout" />,
      selector: 'payout',
      sortable: false,
      cell: row => (
        <p className={`${row?.isTotal ? totalCommonStyle : commonStyle}`}>
          {row?.payout ? <span>&#8377;</span> : ''}
          <span className="ml-1">{numberFormat(row?.payout) || '---'}</span>
        </p>
      ),
      omit: !isAdmin()
    },
    {
      name: <HeaderCommonFormat colName="NR" />,
      selector: 'nr',
      sortable: false,
      cell: row => (
        <p className={`${row?.isTotal ? totalCommonStyle : commonStyle}`}>
          {row?.nr ? <span>&#8377;</span> : ''}
          <span className="ml-1">{numberFormat(row?.nr) || '---'}</span>
        </p>
      ),
      omit: !isAdmin()
    },
    {
      name: <HeaderCommonFormat colName="Comp." />,
      selector: 'comp',
      sortable: false,
      cell: row => (
        <p className={`${row?.isTotal ? totalCommonStyle : commonStyle}`}>
          {row?.comp ? <span>&#8377;</span> : ''}
          <span className="ml-1">{numberFormat(row?.comp) || '---'}</span>
        </p>
      ),
      omit: !isAdmin()
    },
    {
      name: <HeaderCommonFormat colName="Multiple" />,
      selector: 'multiple',
      sortable: false,
      cell: row => {
        let specificStyles = '';
        let parseFloatMultiple = parseFloat(row?.multiple);
        if (parseFloatMultiple >= 3) {
          specificStyles = 'text-green-600 bg-green-200';
        } else if (parseFloatMultiple < 3 && parseFloatMultiple >= 2) {
          specificStyles = 'text-orange-600 bg-orange-50';
        } else if (parseFloatMultiple < 2) {
          specificStyles = 'text-red-400 bg-red-600';
        } else {
          specificStyles = 'text-red-400 bg-red-600';
        }
        return (
          <p
            className={`${
              row?.isTotal ? totalCommonStyle : commonStyle
            } ${specificStyles} p-1 rounded-sm`}
          >
            {row?.multiple !== null ? parseFloatMultiple + 'x' : '---'}
          </p>
        );
      }
    },
    {
      name: <HeaderCommonFormat colName="Net margin" />,
      selector: 'netMargin',
      sortable: false,
      cell: row => (
        <p className={`${row?.isTotal ? totalCommonStyle : commonStyle}`}>
          {row?.netMargin ? <span>&#8377;</span> : ''}
          <span className="ml-1">{numberFormat(row?.netMargin) || '---'}</span>
        </p>
      ),
      omit: !isAdmin()
    }
  ];
};

export default TeamPerformanceTableColumnData;
